export default {
  methods: {
    getCompaniesWithAdminView(companies) {
      if (companies || !companies.length) return [];

      return companies.map(company => ({
        ...company,
        clientView: `${company.name} (${company.entity_type})`,
        adminView:
          company.entity_type === 'Individual'
            ? company.tax_return_name
            : `${company.name} (${company.user.full_name})`,
        superAdminView: `${company.name}`,
      }));
    },
  },
};
